import React from 'react';
import '../../assets/css/solutionlist.css';
import { CMS_LOCATION } from '../../constants/constants';
import { isNullOrUndefined, getOS, saveMetrics, makeCall, checkUrlPath } from "../modules/CommonFunctions";
import { MetricRTCICall } from "./RTCICall";
import { HOME_PAGE_CATEGORY } from '../../constants/constants';

export const SolutionsList = ({PegaSessionID, Title, Items, BannerImage}) => {
    if(BannerImage !== "") {
        let altText = BannerImage.substring(BannerImage.lastIndexOf('/') + 1, BannerImage.lastIndexOf('.'));
        return (
            <React.Fragment>
                <RenderTopSolution ListTitle={Title} ListItem={Items} pegaID={PegaSessionID}/>
                <div className="column small-banner">
                            <img role="presentation" src={CMS_LOCATION+ BannerImage}/>
                </div>
            </React.Fragment>
        )
    } else {
        return (<RenderTopSolution ListTitle={Title} ListItem={Items} pegaID={PegaSessionID}/>)
    }

}

function topSolutionscallBack(solutionItem, pegaSessionID) {
    // if(!isNullOrUndefined(solutionItem.savemetricksId)) {
    //     saveMetrics(solutionItem.savemetricksId);
    // }
    if(!isNullOrUndefined(solutionItem.sclinktrackid)) {
        //window.scLinkTrackID(solutionItem.sclinktrackid);
    }
    // if(!isNullOrUndefined(solutionItem.makecall)) {
    //     let args = solutionItem.makecall.split(',');
    //     makeCall(...args);
    // }
    let args = {
            os: getOS(),
            category: HOME_PAGE_CATEGORY,
            subCategory: null,
            pegaSessionID: pegaSessionID,
            userid: window.userinfo.userId,
            visionID : window.userinfo.visionId,
            accountID: window.userinfo.visionAcctId
    }
    // MetricRTCICall(args);
}

function RenderTopSolution(ListItems){
    return <div className="column  top-solutions-list">   <h3 className="top-solutions-header minus" >{ListItems.ListTitle}</h3> 
    <div className="top-solutions-summary">
        <ul >
            {
                ListItems.ListItem.map((item, index) => {
                   return (<li key={item.linktext} aria-label={item.linktext} >
                        <a href={checkUrlPath(item.linkurl) } data-track={item.linktext} onClick={() => topSolutionscallBack(item, ListItems.pegaID)} tabIndex="0">{ item.linktext }</a>
                    </li>)
                })
            }
        </ul>
    </div>
</div>
}



// WEBPACK FOOTER //
// ./src/components/modules/SolutionsList.js